function sendSimpleForm($form, form, url) {
    $.ajax({
        url: url,
        method: 'POST',
        data: form.serialize(),
        success: function(data) {

            $('.form-line .input-text, .form-line .textarea, .form-line .input-phone', $form).val('');

            const formBlock = $form.find('[data-element="form"]');
            const formSuccessBlock = $form.find('[data-element="success-block"]');
            
            formSuccessBlock.css({
                height: formBlock.height()
            });
            formBlock.hide();
            formSuccessBlock.show();
        },

        error: function (data) {
            
        },

        complete: function () {

        }

    });
}

export default function validation() {

    $('.form-line .input-text, .form-line .textarea').on('blur', function () {

        let $this = $(this);

        if ($this.parents('.form-line').hasClass('_required')) {

            if (!$this.val().match(/[^a-zA-Z А-Яа-яЁё А-ЩЬЮЯҐЄІЇа-щьюяґєії]/gmi) && $this.val().length > 0 && $this.val().length < 50) {

                $this.parents('.form-line').removeClass('form-line--invalid').addClass('form-line--valid');

            } else {

                $this.parents('.form-line').removeClass('form-line--valid').addClass('form-line--invalid');

            }
        }

    });

    $('.form-line .input-email').on('blur', function () {
        let $this = $(this),
            emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;

        if ($this.parents('.form-line').hasClass('_required')) {

            if (!emailReg.test($this.val())) {

                $this.parents('.form-line').removeClass('form-line--valid').addClass('form-line--invalid');

            } else {
                $this.parents('.form-line').removeClass('form-line--invalid').addClass('form-line--valid');
            }

        }
    });

    $('.form-line .input-phone').on('blur', function () {

        let $this = $(this),
            phoneReg = /^\+38 \(\d{3}\) \d{3}(-\d{2}){2}$/;

        if ($this.parents('.form-line').hasClass('_required')) {

            if (!phoneReg.test($this.val())) {
                $this.parents('.form-line').removeClass('form-line--valid').addClass('form-line--invalid');

            } else {
                $this.parents('.form-line').removeClass('form-line--invalid').addClass('form-line--valid');
            }
        }
    });

    $('.form-line select').on('change', function () {
        if($(this).val()) {
            $('.form-line select').parents('.form-line').removeClass('form-line--invalid').addClass('form-line--valid');
        }
    });

    $('button[type="submit"]').on('click', function (e) {
        e.preventDefault();
        let $submit = $(this),
            $form = $submit.parents('.form-box'),
            $button = $(this),
            error = true;

        if ($('.form-line', $form).hasClass('_required') && $('.form-line:not(".form-line--valid, .submit-line")', $form).length > 0) {

            $('.form-line._required:not(".form-line--valid")', $form).each(function () {

                $(this).removeClass('.form-line--valid').addClass('form-line--invalid');
            });
        } else  {
            error = false;

        }

        if(!error) {
            let $alert = $('.alert--success'),
                $alertFail = $('.alert--fail'),
                $alertClose = $('.alert__close'),
                $alertCounter = $('.alert__count span'),
                form = $(this).parents('form'),
                productIdSimple = +$('input[data-product-id-simple]', form).val(),
                url = form.data('action');

            $button.prop('disabled', true);
            $('.input-phone').val($('.input-phone').val().substring(4,19));

            if (form.data('type') === 'simple-form') {
                sendSimpleForm($form, form, url);
                return;
            }
            

            $.ajax({
                url: url,
                method: 'POST',
                data: form.serialize(),
                success: function(data) {

                    $('.form-line .input-text, .form-line .textarea, .form-line .input-phone', $form).val('');

                    $('.modal__close').trigger('click');

                    setTimeout(function () {
                        let prevLocation = window.location.pathname;
                        window.history.replaceState("success", "Дякуємо за замовлення", "/one-click-purchase/checkout-success");
                        $("[data-modal-open='modal-thank-you']").trigger('click');
                        $("[data-modal='modal-thank-you']").on('modal:closed', function () {
                            window.history.replaceState("", "", prevLocation);
                        });
                        $button.prop('disabled', false);
                    }, 700);

                    $('._tym-head').html(`${data.title1}<span>№${data.id}</span> ${data.title2}`);
                    $('._tym-sub').text(data.message);

                    const GTMDataLayer = window.GTMDataLayer;
                    const FBQDataLayer = window.FBQDataLayer;
                    const groupProduct = window.groupProduct || {};
                    const products = groupProduct.products || [];
                    const product = products
                        .map(({id, price, sku}) => ({
                            id,
                            item_id: sku, 
                            price: price,
                            sku: sku
                        }))
                        .find(product => product.id === productIdSimple);
                    
                    if (GTMDataLayer && product) {
                        GTMDataLayer.setProductsInfo([product]);
                        GTMDataLayer.setEcommerceInfo({
                            transaction_id: data.id,
                            coupon: GTMDataLayer.COUPON.FAST_PURCHASE
                        });
                        GTMDataLayer.push(GTMDataLayer.EVENTS.PURCHASE);
                    }
                    

                    if (FBQDataLayer && product) {
                        FBQDataLayer.setProducts([{
                            price: product.price,
                            product: {
                                title: groupProduct.title || '',
                                category_title: groupProduct.category || '',
                                sku: product.sku,
                                type_title: groupProduct.type || ''
                            },
                            quantity: 1,
                        }]);

                        FBQDataLayer.push(FBQDataLayer.EVENTS.PURCHASE);
                    }
                },

                error: function (data) {
                    // console.log(data);
                    $('.modal__close').trigger('click');

                    $alertFail.find('.alert__head').text(data.title);
                    $alertFail.find('.alert__text').text(data.message);

                    $alert.addClass('_active');

                    $alertClose.on('click', function () {
                        $alert.removeClass('_active');
                    });

                    let counter = 9,
                        interval = setInterval(function() {
                            counter--;

                            $alertCounter.text(counter);

                            if (counter == 0) {
                                $alert.removeClass('_active');

                                clearInterval(interval);
                            }
                        }, 1000);
                },

                complete: function () {

                }

            });
        }
    });
}